import { useEffect, useRef, useState } from "react";
import printJS from "print-js";
import BusinessSuiteContentLayout from "layout/business-suite-content/BusinessSuiteContentLayout";
import { Calculator } from "lucide-react";
import { RequestApi, RouteApi, StatusMsg } from "utils";
import { useAppSelector } from "store/store";
import { AppLog } from "services";
import { Sheet, SheetClose, SheetContent } from "components/ui/sheet";
import { useLocation } from "react-router-dom";
import { AppRecord, AppRecordStatus } from "models/appRecord";
import { ShimmerStaffRender } from "components/app/shrimmer/Shrimmer";
import { Snackbar } from "components";
import DailogLeave from "../dialogLeave/DailogLeave";
import BtnGoToTop from "components/app/btn-go-to-top/BtnGoToTop";
import DailogRecalculateLeave from "../dialogLeave/DailogRecalculateLeave";
import PageDetailLeave from "../dialogLeave/PageDetailLeave";
import Status from "../Status";
import LeaveNavbar from "./LeaveNavbar";
import LeaveCard from "./LeaveCard";
import LeaveTable from "./LeaveTable";
import LeaveDepartment from "./LeaveDepartment";
export default function Leave() {
  //*==================Store Glogbal State===============
  const { bntSearch } = useAppSelector((state) => state.header);
  const { token } = useAppSelector((state) => state.auth);
  const location = useLocation();
  //*===============Function==================
  const changeView = (selectedView: string) => {
    setView(selectedView);
    localStorage.setItem("leave", selectedView);
  };
  useState<boolean>(false);
  const handleClickDepartment = ({ departmentName }: { departmentName: string }) => {
    if (selectedProductGroupCode === departmentName) return;
    setSelectedProductGroupCode(departmentName);
    selectedProductGroupCodeRef.current = departmentName;
  };
  const handlePrint = async () => {
    setLoadingPrint(true);
    try {
      const url = `${storage_host_cluster_Id.host_name}/api-mobile-flipflop/v1/get-shop-employee-leave-report?token=${token}`;
      const data = {
        shop_id: shopId,

        entitlement_year: selectedYear,
        search_text: searchTextInput,
        department: selectedProductGroupCode,
        storage_host_cluster_id: storage_host_cluster_Id.id,
      };

      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        setLoadingPrint(false);
        const pdfUrl = response?.pdf_url;
        const pdfResponse = await fetch(pdfUrl);
        const blob = await pdfResponse.blob();
        const blobUrl = URL.createObjectURL(blob);
        printJS({ printable: blobUrl, type: "pdf" });
      } else {
        setLoadingPrint(false);

        console.log(response, "error fetch shop employee");
      }
    } catch (error) {
      setLoadingPrint(false);
      setShopEmployeeLeaveLoadingState(false);

      AppLog.show({
        message: `[handlePrint]`,
        status: StatusMsg.error,
        error,
      });
    }
  };
  const handleToggleSelectAll = () => {
    if (isAllSelected) {
      // Deselect all
      setSelectedProductIds([]);
    } else {
      // Select all
      setSelectedProductIds(allIds);
    }
  };
  const getShopEmployeeLeaveSearch = async () => {
    setShopEmployeeLeaveLoadingState(true);
    try {
      const url = `${RouteApi.getShopEmployeeLeaveSearch}token=${token}`;
      const data = {
        shop_id: shopId,
        entitlement_month: selectedMonth + 1,
        entitlement_year: selectedYear,
        search_text: searchTextInput,
        department: selectedProductGroupCode,
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        setShopEmployeeLeaveLoadingState(false);
        const stateRecord: AppRecord = {
          currentPage: 1,
          currentIndex: 0,
          nextPageUrl: response["employee_entitlements"]["next_page_url"] ?? "",
          totalRecord: 0,
          loadingStatus: response["employee_entitlements"]["next_page_url"] != null ? AppRecordStatus.loaded : AppRecordStatus.noLoadMore,
        };
        setShopEmployeeLeave(response.employee_entitlements);

        setShopEmployeeLeaveLoading(stateRecord);
      } else {
        console.log(response, "error fetch shop employee ");
      }
    } catch (error) {
      setShopEmployeeLeaveLoadingState(false);

      AppLog.show({
        message: `[getShopEmployeeTimesheetSearch]`,
        status: StatusMsg.error,
        error,
      });
    }
  };
  const fetchMoreShopEmployeeLeaveSearch = async ({ next }: { next: string }) => {
    if (!next) return;

    setShopEmployeeLeaveLoading({
      ...loadingProductState,
      loadingStatus: AppRecordStatus.loadingMore,
    });

    try {
      const responses = await RequestApi(next);

      if (responses.status === "success") {
        const newEmployees = responses["employee_entitlements"]["data"];
        const nextPage = responses["employee_entitlements"]["next_page_url"];

        const updatedData = [...(shopEmployeeLeave?.data || []), ...newEmployees];

        setShopEmployeeLeave({
          ...responses["employee_entitlements"],
          data: updatedData,
        });

        setShopEmployeeLeaveLoading({
          ...loadingProductState,
          nextPageUrl: nextPage ?? "",
          loadingStatus: nextPage ? AppRecordStatus.loaded : AppRecordStatus.noLoadMore,
        });
      }
    } catch (error) {
      console.error("Failed to fetch more employees:", error);
    }
  };
  const handleClick = (title: string) => {
    if (title === "Recalculate") {
      setIsDailogRecalculateLeave(true);
    } else {
      Snackbar({
        message: `Coming soon ${title}`,
        status: StatusMsg.warning,
      });
    }
    // }, 300); // simulate a short delay
  };
  const getShopEmployeeLeaveCalculation = async () => {
    setLoadingEmployeesLeaveCalcaulation(true);
    try {
      const url = `${RouteApi.getShopEmployeeLeaveCalculation}token=${token}`;
      const data = {
        shop_id: shopId,
        entitlement_month: selectedMonth + 1,
        entitlement_year: selectedYear,
        search_text: searchTextInput,
        department: selectedProductGroupCode,
        payroll_step: "",
        reset: statusReset,
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        setLoadingEmployeesLeaveCalcaulation(false);
        setUserShopEmployeesLeaveCalculation(response.user_shop_employees.data);
      } else {
        setLoadingEmployeesLeaveCalcaulation(false);

        console.log(response, "error fetch shop employee ");
      }
    } catch (error) {
      setLoadingEmployeesLeaveCalcaulation(false);

      AppLog.show({
        message: `[getShopEmployeeTimesheetSearch]`,
        status: StatusMsg.error,
        error,
      });
    }
  };
  const getShopEmployeeLeaveDetail = async (employee_id: any, leave_type: any) => {
    setLoadingEmployeeLeaveDetail(true);
    try {
      const url = `${RouteApi.getShopEmployeeLeaveDetail}token=${token}`;
      const data = {
        shop_id: shopId,
        employee_id: employee_id,
        leave_type: leave_type,
        entitlement_year: selectedYear,
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        setLoadingEmployeeLeaveDetail(false);
        setEmployeeLeaveDetail(response.employee_entitlements);
      }
    } catch (error) {
      setLoadingEmployeeLeaveDetail(false);

      AppLog.show({
        message: `[getShopEmployeeLeaveDetail]`,
        status: StatusMsg.error,
        error,
      });
    }
  };
  const getShopEmployeeLeaveDepartment = async () => {
    setloadingDepartmentLeave(true);
    try {
      const url = `${RouteApi.getShopEmployeeLeaveDepartment}token=${token}`;
      const data = {
        shop_id: shopId,
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        setloadingDepartmentLeave(false);
        setDepartmentLeave(response.user_shop_departments);
        setStorage_host_cluster_Id(response.storage_host_cluster);

        setAttendanceSetting({
          early_exception: response.attendance_setting.early_exception,
          late_exception: response.attendance_setting.late_exception,
          max_compassionate_leave: response.attendance_setting.max_compassionate_leave,
          max_change_day_off_leave: response.attendance_setting.max_change_day_off_leave,
          max_marriage_leave: response.attendance_setting.max_marriage_leave,
          max_maternity_leave: response.attendance_setting.max_maternity_leave,
          max_paternity_leave: response.attendance_setting.max_paternity_leave,
          max_special_leave: response.attendance_setting.max_special_leave,
          max_suspend_leave: response.attendance_setting.max_suspend_leave,
          max_unpaid_leave: response.attendance_setting.max_unpaid_leave,
          annual_leave: response.attendance_setting.annual_leave,
          sick_leave: response.attendance_setting.sick_leave,
          max_block_leave: response.attendance_setting.max_block_leave,
          max_sick_leave: response.attendance_setting.max_sick_leave,
          max_annual_leave: response.attendance_setting.max_annual_leave,
        });
      } else {
        setloadingDepartmentLeave(false);

        setErrorStatus({
          title: response.status,
          message: response.msg,
        });
        setWarning(true);
      }
    } catch (error) {
      setloadingDepartmentLeave(false);
      AppLog.show({
        message: `[getShopEmployeeLeaveDepartment]`,
        status: StatusMsg.error,
        error,
      });
    }
  };
  const handleChangeMonth = (key: string, val: string) => {
    setMonthDay((prev) => ({
      ...prev,
      [key]: val,
    }));
  };
  const saveUpdateLeaveDeduction = async (key: string, id: number, isEndDay = false) => {
    setLoadingsubmitUpdateLeaveDeduction(true);
    try {
      const working_hour = isEndDay ? monthDay1[key] : monthDay[key];
      const url = `${RouteApi.saveUpdateLeaveDeduction}token=${token}`;
      const data = {
        shop_id: shopId,
        id: id,
        entitlement_year: selectedYear,
        entitlement_month: !monthTableClick ? selectedMonth + 1 : monthTable,
        working_hour: working_hour, // save only 1 value
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        setLoadingsubmitUpdateLeaveDeduction(false);
        setOpenPopoverKey(null);
        setMonthTableClick(false);
        setShopEmployeeLeave((prev: any) => ({
          ...prev,
          data: prev.data.map((item: any) => (item.id === response.employee_entitlement.id ? response.employee_entitlement : item)),
        }));
      } else {
        setLoadingsubmitUpdateLeaveDeduction(false);
      }
    } catch (error) {
      console.error("Error saving leave deduction:", error);
      setLoadingsubmitUpdateLeaveDeduction(false);
      AppLog.show({
        message: `[submitUpdateClockTime]`,
        status: StatusMsg.error,
        error,
      });
    } finally {
      setLoadingsubmitUpdateLeaveDeduction(false);
    }
  };
  //*===============Variable==================
  const listRef = useRef<any>(null);
  const [openDrawer, setOpenDrawer] = useState<number | null>(null);
  const currentYear = new Date().getFullYear();
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth());
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  const years = Array.from({ length: 100 }, (_, i) => currentYear - i);
  const [searchTextInput, setSearchTextInput] = useState<string>("");
  const [selectedProductGroupCode, setSelectedProductGroupCode] = useState<string>("");
  const [view, setView] = useState("card");
  const searchParams = new URLSearchParams(location.search);
  const shopId = searchParams.get("id");
  const selectedProductGroupCodeRef = useRef(selectedProductGroupCode);
  const [selectProducts, setSelectProducts] = useState<boolean>(false);
  const [selectedProductIds, setSelectedProductIds] = useState<string[]>([]);
  const [hovered, setHovered] = useState(false);
  const [shopEmployeeLeave, setShopEmployeeLeave] = useState<any>();
  const [shopEmployeeLeaveLoading, setShopEmployeeLeaveLoading] = useState<any>(null);
  const [shopEmployeeLeaveLoadingState, setShopEmployeeLeaveLoadingState] = useState<any>(null);
  const [storage_host_cluster_Id, setStorage_host_cluster_Id] = useState<any>();
  const [departmentLeave, setDepartmentLeave] = useState<any>();
  const [loadingDepartmentLeave, setloadingDepartmentLeave] = useState<boolean>(false);
  const [isDailogRecalculateLeave, setIsDailogRecalculateLeave] = useState<boolean>(false);
  const [loadingPrint, setLoadingPrint] = useState<boolean>(false);
  const [dailogLeave, setIsDailogLeave] = useState<boolean>(false);
  const [userShopEmployeesLeaveCalculation, setUserShopEmployeesLeaveCalculation] = useState<any>();
  const [loadingEmployeesLeaveCalcaulation, setLoadingEmployeesLeaveCalcaulation] = useState<boolean>(false);
  let statusReset: string = "";
  const [monthDay, setMonthDay] = useState<{ [key: string]: string }>({});
  const [monthDay1, setMonthDay1] = useState<{ [key: string]: string }>({});
  const [monthTable, setMonthTable] = useState<number>();
  const [monthTableClick, setMonthTableClick] = useState<boolean>(false);
  const [loadingsubmitUpdateLeaveDeduction, setLoadingsubmitUpdateLeaveDeduction] = useState<boolean>(false);
  const [openPopoverKey, setOpenPopoverKey] = useState<{ row: number; month: string } | null>(null);
  const [employeeLeaveDetail, setEmployeeLeaveDetail] = useState<any>();
  const [loadingEmployeeLeaveDetail, setLoadingEmployeeLeaveDetail] = useState<boolean>(false);
  const [attendanceSetting, setAttendanceSetting] = useState<any>({
    early_exception: "",
    late_exception: "",
  });
  const [openPopoverSetting, setOpenPopoverSetting] = useState<number | null>(null);
  const [errorStatus, setErrorStatus] = useState({
    title: "",
    message: "",
  });
  const [warning, setWarning] = useState(false);
  const allIds = Array.isArray(shopEmployeeLeave?.data) ? shopEmployeeLeave?.data?.map((item: any) => item.id) : [];
  const isAllSelected = allIds.length > 0 && allIds.every((id: any) => selectedProductIds.includes(id));
  const loadingProductState = {
    currentPage: 1,
    currentIndex: 0,
    nextPageUrl: "",
    totalRecord: 0,
    loadingStatus: AppRecordStatus.loading,
  };
  //*===============Ueffect==================
  useEffect(() => {
    if (listRef.current && shopEmployeeLeaveLoading?.nextPageUrl && listRef.current.scrollHeight < window.innerHeight) {
      fetchMoreShopEmployeeLeaveSearch({
        next: shopEmployeeLeaveLoading?.nextPageUrl,
      });
    } else {
      console.log("Error");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shopEmployeeLeave?.data]);
  useEffect(() => {
    const savedView = localStorage.getItem("leave");
    if (savedView) {
      setView(savedView);
    }
    getShopEmployeeLeaveSearch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTextInput, selectedProductGroupCode, selectedYear, selectedMonth + 1, bntSearch]);
  useEffect(() => {
    getShopEmployeeLeaveDepartment();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const dataTimesheets = [
    {
      id: 1,
      title: "Recalculate",
      label: " Recalculate employee timesheets.",
      icon: (
        <div className="w-8 h-8 flex items-center justify-center bg-green-500 text-white p-2 rounded-full">
          <Calculator />
        </div>
      ),
      description: [
        <>
          <p className="mb-2 font-medium text-sm text-gray-800">Recalculate totals based on the latest timesheet data and changes.</p>
          <ul className="list-disc pl-5 text-sm text-gray-700 space-y-1">
            <li>Updates total working hours, overtime, and payroll calculations.</li>
            <li>Ensures all edits (clock-ins, breaks, shifts) are accurately reflected.</li>
            <li>Run this after importing, editing, or approving timesheets.</li>
          </ul>
        </>,
      ],
    },
  ];
  useEffect(() => {
    if (shopEmployeeLeave?.data?.length) {
      const monthMap = ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"];

      // Adjust month index correctly (assuming monthTable is 1–12)
      const monthIndex: number = monthTableClick === true ? Number(monthTable) - 1 : Number(selectedMonth);

      const currentMonthKey = monthMap[monthIndex] || "unknown";

      console.log(monthIndex, "monthIndex");
      console.log(currentMonthKey, "currentMonthKey");

      const usedKey = `${currentMonthKey}_used_day`;
      const usedDayMap: Record<string, string> = {};

      shopEmployeeLeave.data.forEach((item: any, index: number) => {
        usedDayMap[`${index}-${currentMonthKey}`] = item[usedKey] || "";
      });

      setMonthDay(usedDayMap);
    }
  }, [shopEmployeeLeave, monthTableClick, selectedMonth, monthTable]);
  //*===============Prop==================
  const leaveNavbarProp = {
    selectProducts,
    selectedProductIds,
    allIds,
    getShopEmployeeLeaveCalculation,
    setIsDailogLeave,
    openPopoverSetting,
    setSelectProducts,
    isAllSelected,
    handleToggleSelectAll,
    setSelectedProductIds,
    handlePrint,
    loadingPrint,
    setSearchTextInput,
    view,
    changeView,
    setOpenPopoverSetting,
    dataTimesheets,
    handleClick,
    attendanceSetting,
    setAttendanceSetting,
    selectedYear,
    setSelectedYear,
    years,
    months,
    selectedMonth,
    setSelectedMonth,
  };
  const leaveCardProp = {
    shopEmployeeLeave,
    fetchMoreShopEmployeeLeaveSearch,
    shopEmployeeLeaveLoading,
    listRef,
    selectedMonth,
    selectProducts,
    setSelectedProductIds,
    selectedProductIds,
    setOpenDrawer,
    getShopEmployeeLeaveDetail,
    openPopoverKey,
    setOpenPopoverKey,
    setMonthTableClick,
    monthDay,
    handleChangeMonth,
    saveUpdateLeaveDeduction,
    loadingsubmitUpdateLeaveDeduction,
  };
  const leaveTableProp = {
    shopEmployeeLeave,
    fetchMoreShopEmployeeLeaveSearch,
    shopEmployeeLeaveLoading,
    listRef,
    selectedMonth,
    selectProducts,
    setSelectedProductIds,
    selectedProductIds,
    setOpenDrawer,
    getShopEmployeeLeaveDetail,
    openPopoverKey,
    setOpenPopoverKey,
    setMonthTableClick,
    monthDay,
    handleChangeMonth,
    saveUpdateLeaveDeduction,
    loadingsubmitUpdateLeaveDeduction,
    shopEmployeeLeaveLoadingState,
    setMonthTable,
  };
  const leaveDepartment = {
    hovered,
    setHovered,
    selectedProductGroupCode,
    handleClickDepartment,
    loadingDepartmentLeave,
    departmentLeave,
  };

  return (
    <BusinessSuiteContentLayout>
      <div className=" max-w-full z-50 w-auto bg-white sticky top-0 dark:bg-[#020817]">
        <div className={`flex ${window.innerWidth <= 1500 ? "flex-col items-start" : "flex-row  justify-between left-0 items-center "} mb-3 w-full `}>
          <div className="text-start lg:w-auto md:w-auto w-full ">
            <h1 className="font-semibold lg:text-lg md:text-md sm:text-sm">Leave Entitlements</h1>
            <p className=" whitespace-nowrap text-muted-foreground lg:text-md md:text-sm text-[13px]">Streamlining Employee Leave Management with Accuracy and Compliance.</p>
          </div>
          {warning ? "" : <LeaveNavbar {...leaveNavbarProp} />}
        </div>

        {warning ? "" : <LeaveDepartment {...leaveDepartment} />}
      </div>
      {warning ? (
        <Status errorStatus={errorStatus} className="h-[70vh]" />
      ) : (
        <div className="pb-3 h-full mt-5 bg-red">
          {view === "card" ? (
            <>
              {shopEmployeeLeaveLoadingState ? (
                <>
                  <ShimmerStaffRender />
                </>
              ) : (
                <LeaveCard {...leaveCardProp} />
              )}
            </>
          ) : (
            <>{shopEmployeeLeave ? <LeaveTable {...leaveTableProp} /> : <></>}</>
          )}
        </div>
      )}
      <DailogLeave
        onReset={({ status }) => {
          if (status === "yes") {
            statusReset = "Yes";
            getShopEmployeeLeaveCalculation();
          } else {
            statusReset = "";
          }
        }}
        userShopEmployeesLeaveCalculation={userShopEmployeesLeaveCalculation}
        dailogLeave={dailogLeave}
        setIsDailogLeave={setIsDailogLeave}
        editItemCategories={""}
        filteredData={undefined}
        userShopShiftGroup={undefined}
        setFilteredData={undefined}
        searchTextInput={""}
        loadingEmployeesCalcaulation={loadingEmployeesLeaveCalcaulation}
      />
      <DailogRecalculateLeave
        onUploadSuccess={({ status }) => {
          if (status === "success") {
            setSelectedProductIds([]);
            setSelectProducts(false);
          } else {
          }
        }}
        isDailogRecalculateLeave={isDailogRecalculateLeave}
        setIsDailogRecalculateLeave={setIsDailogRecalculateLeave}
        selectedProductIds={selectedProductIds}
      />
      <Sheet
        open={openDrawer === 1}
        onOpenChange={(isOpen) => {
          setOpenDrawer(isOpen ? 1 : null);
          if (!isOpen) {
            const url = new URL(window.location.href);
            url.searchParams.delete("employee_id");
            url.searchParams.delete("working_data");
            window.history.pushState({}, "", url.toString());
          }
        }}
      >
        <SheetContent className="flex flex-col h-full sm:max-w-[600px] justify-between p-3 pt-[50px]">
          <PageDetailLeave
            selectedYear={selectedYear}
            setOpenDrawer={setOpenDrawer}
            attendanceSetting={attendanceSetting}
            loadingPrint={loadingPrint}
            onUploadSuccess={({ status }) => {
              if (status === "print") {
              } else {
              }
            }}
            isDailogTimesheets={false}
            employeeLeaveDetail={employeeLeaveDetail}
            loadingEmployeeLeaveDetail={loadingEmployeeLeaveDetail}
          />
          <SheetClose className=" hidden" />
        </SheetContent>
      </Sheet>
      <BtnGoToTop />
    </BusinessSuiteContentLayout>
  );
}
